import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent implements OnInit {
 
  constructor(public nav:NavController) {
  }
  ngOnInit(){
  }

  ngOnDestroy(){
  }
}
